var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-image__preview"},_vm._l((_vm.tValue),function(item){return _c('el-link',{key:item.att_id,staticClass:"el-icon-document",attrs:{"href":item.att_url,"target":"_blank"}},[_vm._v(_vm._s(item.att_title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }